import { render, staticRenderFns } from "./insFile.vue?vue&type=template&id=1a282063&scoped=true&"
import script from "./insFile.vue?vue&type=script&lang=js&"
export * from "./insFile.vue?vue&type=script&lang=js&"
import style0 from "./insFile.vue?vue&type=style&index=0&id=1a282063&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a282063",
  null
  
)

export default component.exports